import { FC } from "react";
import SearchIcon from "@svg/header/search";
import SearchbarSVGLogo from "@svg/home/SearchbarSvgLogo";

interface Props {
  defaultValue: string;
}

export const SearchInputWithLogo: FC<Props> = ({ defaultValue }) => {
  return (
    <div className="relative rounded-6 flex items-center px-2 grow h-10 border border-fds-divider focus-within:text-blue-500 text-fds-icon-secondary">
      <SearchIcon className="cursor-pointer" />
      <span className="mr-1.5  ml-1 text-xs">
        {defaultValue ?? "جستجوی آموزش در"}
      </span>
      {defaultValue ? null : <SearchbarSVGLogo className="h-5    w-10" />}
    </div>
  );
};
